var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wb-content-wrapper',{attrs:{"state":_vm.state}},[_c('h1',[_vm._v("Loan Order Application")]),_c('p',[_vm._v("Coming soon 😘")])])}
var staticRenderFns = []

export { render, staticRenderFns }